import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["DialogPortal"], { disabled: $props.disablePortal }, {
        default: _withCtx(() => [
            _createVNode($setup["SheetOverlay"]),
            _createVNode($setup["DialogContent"], _mergeProps({
                "data-slot": "sheet-content",
                class: $setup.cn('bg-background data-[state=open]:animate-in data-[state=closed]:animate-out fixed z-50 flex flex-col gap-4 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500', $props.side === 'right'
                    && 'data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right inset-y-0 right-0 h-full w-3/4 border-l sm:max-w-sm', $props.side === 'left'
                    && 'data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left inset-y-0 left-0 h-full w-3/4 border-r sm:max-w-sm', $props.side === 'top'
                    && 'data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top inset-x-0 top-0 h-auto border-b', $props.side === 'bottom'
                    && 'data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom inset-x-0 bottom-0 h-auto border-t', $setup.props.class)
            }, { ..._ctx.$attrs, ...$setup.forwarded }), {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default"),
                    ($props.showCloseButton)
                        ? (_openBlock(), _createBlock($setup["DialogClose"], {
                            key: 0,
                            class: "ring-offset-background focus:ring-ring data-[state=open]:bg-secondary absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none"
                        }, {
                            default: _withCtx(() => [
                                _createVNode($setup["X"], { class: "size-4" }),
                                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "sr-only" }, "Close", -1 /* CACHED */))
                            ]),
                            _: 1 /* STABLE */
                        }))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 3 /* FORWARDED */
            }, 16 /* FULL_PROPS */, ["class"])
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["disabled"]));
}
